import { Secret } from '@/utils/secretsManager';
import { getSessionStorage } from '@/utils/sessionStorage';
import { useEffect, useState } from 'react';

const StatusWidget = () => {
    const [status, setStatus] = useState<number | null>(null);
    const secrets = getSessionStorage('secrets') as Secret | null;

    const statusColors: Record<number, string> = {
        1: 'bg-[#35955f]', // Operational
        2: 'bg-[#0c91c3]', // Performance issues
        3: 'bg-[#F34213]', // Partial outage
        4: 'bg-[#d62828]' // Major outage
    };

    useEffect(() => {
        if (!secrets?.statusPageURL) return;

        fetch(`${secrets.statusPageURL}/api/v1/components`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((data) => {
                const statuses = data.data.map((component) => component.status);
                const highestStatus = Math.max(...statuses);
                setStatus(highestStatus);
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error('Error Fetching Status', error);
            });
    }, [secrets?.statusPageURL]);

    if (!secrets?.statusPageURL || status === null) return null;

    return (
        <a href={secrets.statusPageURL} target='_blank' rel='noopener noreferrer' className='no-underline text-black dark:text-white bg-transparent border-b-0'>
            <div className="p-2.5 flex gap-5 items-center relative status-badge">
                <span>Status:</span>
                <span className={`inline-block w-14 h-14 rounded-full animation-pulse status-online ${statusColors[status!] || 'bg-gray-500'}`}></span>
            </div>
        </a>
    );

};

export default StatusWidget;
